/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section5body32Inputs */

const id_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk informasi lebih lanjut tentang perlindungan data dan penggunaan wajar di Uni Eropa, silakan merujuk ke sumber daya berikut:`)
};

const ms_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk maklumat lanjut tentang perlindungan data dan penggunaan adil di Kesatuan Eropah, sila rujuk sumber berikut:`)
};

const da_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For mere information om databeskyttelse og fair use i Den Europæiske Union, henvises til følgende ressourcer:`)
};

const de_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für weitere Informationen zum Datenschutz und zur fairen Nutzung in der Europäischen Union verweisen wir auf die folgenden Ressourcen:`)
};

const en_us2_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For more information on data protection and fair use in the European Union, please refer to the following resources:`)
};

const es_es2_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para más información sobre la protección de datos y el uso justo en la Unión Europea, consulta los siguientes recursos:`)
};

const es_mx2_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para más información sobre la protección de datos y el uso justo en la Unión Europea, consulta los siguientes recursos:`)
};

const fil_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para sa karagdagang impormasyon tungkol sa proteksyon ng data at patas na paggamit sa European Union, mangyaring sumangguni sa mga sumusunod na mapagkukunan:`)
};

const fr_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour plus d'informations sur la protection des données et l'utilisation équitable dans l'Union européenne, veuillez consulter les ressources suivantes :`)
};

const it_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per maggiori informazioni sulla protezione dei dati e sul fair use nell'Unione Europea, consulta le seguenti risorse:`)
};

const hu_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az adatvédelemről és a fair use-ról az Európai Unióban további információkért kérjük, tekintse meg a következő forrásokat:`)
};

const nl_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor meer informatie over gegevensbescherming en fair use in de Europese Unie, raadpleeg de volgende bronnen:`)
};

const no_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For mer informasjon om databeskyttelse og rimelig bruk i EU, vennligst se følgende ressurser:`)
};

const pl_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aby uzyskać więcej informacji na temat ochrony danych i dozwolonego użytku w Unii Europejskiej, zapoznaj się z następującymi zasobami:`)
};

const pt_br2_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para obter mais informações sobre proteção de dados e uso justo na União Europeia, consulte os seguintes recursos:`)
};

const pt_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para mais informações sobre proteção de dados e uso justo na União Europeia, consulte os seguintes recursos:`)
};

const ro_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pentru mai multe informații despre protecția datelor și utilizarea corectă în Uniunea Europeană, consultați următoarele resurse:`)
};

const fi_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisätietoja tietosuojasta ja kohtuullisesta käytöstä Euroopan unionissa on seuraavissa resursseissa:`)
};

const sv_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För mer information om dataskydd och skälig användning i Europeiska unionen, se följande resurser:`)
};

const vi_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để biết thêm thông tin về bảo vệ dữ liệu và sử dụng hợp lý tại Liên minh Châu Âu, vui lòng tham khảo các nguồn sau:`)
};

const tr_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avrupa Birliği'nde veri koruma ve adil kullanım hakkında daha fazla bilgi için lütfen aşağıdaki kaynaklara bakın:`)
};

const cs_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další informace o ochraně údajů a spravedlivém použití v Evropské unii naleznete v následujících zdrojích:`)
};

const bg_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За повече информация относно защитата на данните и честната употреба в Европейския съюз, моля, вижте следните ресурси:`)
};

const ru_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для получения дополнительной информации о защите данных и добросовестном использовании в Европейском Союзе, пожалуйста, обратитесь к следующим ресурсам:`)
};

const uk_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для отримання додаткової інформації про захист даних та добросовісне використання в Європейському Союзі зверніться до наступних ресурсів:`)
};

const ar_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لمزيد من المعلومات حول حماية البيانات والاستخدام العادل في الاتحاد الأوروبي، يرجى الرجوع إلى الموارد التالية:`)
};

const hi_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक जानकारी के लिए:`)
};

const th_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการปกป้องข้อมูลและการใช้งานโดยชอบในสหภาพยุโรป โปรดดูแหล่งข้อมูลต่อไปนี้:`)
};

const ja_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU におけるデータ保護とフェアユースの詳細については、以下のリソースを参照してください：`)
};

const zh_cn2_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有关欧盟数据保护和合理使用的更多信息，请参阅以下资源：`)
};

const zh_hant1_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有關歐盟資料保護和合理使用的更多資訊，請參閱以下資源：`)
};

const ko_misc_fairuse_section5body32 = /** @type {(inputs: Misc_Fairuse_Section5body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유럽 연합의 데이터 보호 및 공정 사용에 대한 자세한 내용은 다음 리소스를 참조하세요:`)
};

/**
* | output |
* | --- |
* | "For more information on data protection and fair use in the European Union, please refer to the following resources:" |
*
* @param {Misc_Fairuse_Section5body32Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section5body32 = /** @type {((inputs?: Misc_Fairuse_Section5body32Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section5body32Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section5body32(inputs)
	if (locale === "ms") return ms_misc_fairuse_section5body32(inputs)
	if (locale === "da") return da_misc_fairuse_section5body32(inputs)
	if (locale === "de") return de_misc_fairuse_section5body32(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section5body32(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section5body32(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section5body32(inputs)
	if (locale === "fil") return fil_misc_fairuse_section5body32(inputs)
	if (locale === "fr") return fr_misc_fairuse_section5body32(inputs)
	if (locale === "it") return it_misc_fairuse_section5body32(inputs)
	if (locale === "hu") return hu_misc_fairuse_section5body32(inputs)
	if (locale === "nl") return nl_misc_fairuse_section5body32(inputs)
	if (locale === "no") return no_misc_fairuse_section5body32(inputs)
	if (locale === "pl") return pl_misc_fairuse_section5body32(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section5body32(inputs)
	if (locale === "pt") return pt_misc_fairuse_section5body32(inputs)
	if (locale === "ro") return ro_misc_fairuse_section5body32(inputs)
	if (locale === "fi") return fi_misc_fairuse_section5body32(inputs)
	if (locale === "sv") return sv_misc_fairuse_section5body32(inputs)
	if (locale === "vi") return vi_misc_fairuse_section5body32(inputs)
	if (locale === "tr") return tr_misc_fairuse_section5body32(inputs)
	if (locale === "cs") return cs_misc_fairuse_section5body32(inputs)
	if (locale === "bg") return bg_misc_fairuse_section5body32(inputs)
	if (locale === "ru") return ru_misc_fairuse_section5body32(inputs)
	if (locale === "uk") return uk_misc_fairuse_section5body32(inputs)
	if (locale === "ar") return ar_misc_fairuse_section5body32(inputs)
	if (locale === "hi") return hi_misc_fairuse_section5body32(inputs)
	if (locale === "th") return th_misc_fairuse_section5body32(inputs)
	if (locale === "ja") return ja_misc_fairuse_section5body32(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section5body32(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section5body32(inputs)
	return ko_misc_fairuse_section5body32(inputs)
});
export { misc_fairuse_section5body32 as "misc.fairUse.section5Body3" }